import { API_VERSIONS, asinzenAdminApi } from "client/api";

export const getSpTokenPoolList = () =>
  asinzenAdminApi({
    headers: {
      "content-type": "application/json",
    }
  })
    .get(`/${API_VERSIONS}/admin/sp-token-pool/get-items`)

export const addSpTokenPool = (params: any) =>
  asinzenAdminApi({
    headers: {
      "content-type": "application/json",
    }
  })
    .post(`/${API_VERSIONS}/admin/sp-token-pool/add`, params)

export const deleteSpTokenPool = (id: string) =>
  asinzenAdminApi({
    headers: {
      "content-type": "application/json",
    }
  })
    .delete(`/${API_VERSIONS}/admin/sp-token-pool/${id}/delete`)

export const validateSpTokenAuth = (tokenId: string, params: any) =>
  asinzenAdminApi({
    headers: {
      "content-type": "application/json",
    }
  })
    .post(`/${API_VERSIONS}/admin/sp-token-pool/${tokenId}/validate`, params)
